module.exports = __webpack_public_path__ + "img/logo_share.d1191d28.svg";